<template>
  <div class="page">
    <div class="content">
      <!-- Sol kısım: Header + Chart -->
      <div class="left-side">
        <TurboHeader
          v-model:symbol="symbol"
          :symbol-options="symbolOptions"
          v-model:interval="interval"
        />
        <TurboTradeChart
          :symbol="symbol"
          :direction="direction"
          :history-seconds="historySeconds"
          :end-time-sec="endTimeSec"
          :entry-price="externalEntryPrice"
          :interval="interval"
          price-scale="normal"
          @entry-fixed="onEntryFixed"
          @price-update="onPriceUpdate" 
        />
      </div>

      <!-- Sağ kısım: Bet Input -->
      <div class="bet-panel">
        <!-- ✅ Burada user ve socket gönderiyoruz -->
        <BetInput :symbol="symbol" :user="authUser" :socket="socket" />
      </div>
      
    </div>
    <FuturesPositions />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { io } from 'socket.io-client'

import TurboTradeChart from '@/components/futures/TurboTradeChart.vue'
import TurboHeader from '@/components/futures/TurboHeader.vue'
import BetInput from '@/components/futures/BetInput.vue'
import FuturesPositions from '@/components/futures/FuturesPositions.vue'


const store = useStore()
const authUser = computed(() => store.getters.authUser.user)

// ✅ socket bağlantısı
const socket = io(process.env.VUE_APP_SOCKET_URL, {
  transports: ['websocket'],
  withCredentials: true
})

const symbol = ref('DOGEUSDT')
const symbolOptions = ref([
  'BTCUSDT','ETHUSDT','USDCUSDT','SOLUSDT','XRPUSDT','DOGEUSDT','LINKUSDT','BNBUSDT',
  'ADAUSDT','SUIUSDT','AVAXUSDT','LTCUSDT','PEPEUSDT','UNIUSDT','TRXUSDT','DOTUSDT','WLDUSDT'
])

const currentPrice = ref(null)

function onPriceUpdate(price) {
  currentPrice.value = price
}

const interval = ref('tick')
const durationSec = ref(30)
const direction = ref('UP')
const endTimeSec = ref(null)
const externalEntryPrice = ref(null)
const historySeconds = ref(90)

function onEntryFixed(p) {
  console.log('Entry fixed:', p)
}
</script>


<style scoped>
.page {
  
 
  padding: 0 10px;
}

/* PC: sol (header+chart) sağ (bet input) */
.content {
  display: flex;
  gap: 20px;
}

/* Sol taraf dikey düzen */
.left-side {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 300px; /* ✅ chart’ın minimum yüksekliği */
}

.turbo-trade-chart {
  flex: 1;
  min-height: 250px;
  max-height: 500px;
}


/* Sağ panel */
.bet-panel {
  width: 300px;
  flex-shrink: 0;
}

/* Mobil: alt alta */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }
  .bet-panel {
    width: 100%;
  }
}
</style>
